// NOTE: IMPORT OTHER CONSTANTS AND DEPENDENCIES
import Root from "../Layout/Root";
import { createBrowserRouter } from "react-router-dom";

// NOTE: IMPORT COMMON PAGES
import ErrorPage from "../error/Error";
import InternalServerError from "../error/ServerError";
import NotFoundPage from "../error/NotFoundError";

// IMPORT SERVICES PAGE
import Services from "../pages/Services";

// NOTE: IMPORT HOOKS
import {
  ProtectedReviewRoute,
  PublicRoute,
} from "../components/protectedAndPublicRoute";
import Home from "../pages/Home";

// IMPORT LANDLORD NAVIGATION PAGES
import ContactUs from "../pages/ContactUs";
import LifeAtRoselea from "../pages/LifeAtRoselea";
import AboutUs from "../pages/AboutUs/AboutUs";
import Profile from "../pages/Profile";

import LayoutWithRole from "../pages/LayoutWithRole";

const router = createBrowserRouter([
  {
    path: "/",
    element: <PublicRoute />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "",
        element: <Root />,
        children: [
          {
            index: true,
            element: <Home />,
          },
        ],
      },
      {
        path: "/contact-us",
        element: <Root />,
        children: [
          {
            index: true,
            element: <ContactUs />,
          },
        ],
      },
      {
        path: "/life-at-roselea",
        element: <Root />,
        children: [
          {
            index: true,
            element: <LifeAtRoselea />,
          },
          {
            path: "home",
            element: <Home />,
          },
        ],
      },
      {
        path: "/about",
        element: <Root />,
        children: [
          {
            index: true,
            element: <AboutUs />,
          },
          {
            path: "home",
            element: <Home />,
          },
        ],
      },
      {
        path: "/services",
        element: <Root />,
        children: [
          {
            index: true,
            element: <Services />,
          },
        ],
      },
    ],
  },

  {
    path: "/review",
    element: <ProtectedReviewRoute />,
    errorElement: <ErrorPage />,
    children: [
      {
        element: <Root />,
        children: [
          {
            index: true,
            element: <LayoutWithRole />,
          },
        ],
      },
    ],
  },
  {
    path: "/profile",
    element: <ProtectedReviewRoute />,
    errorElement: <ErrorPage />,
    children: [
      {
        element: <Root />,
        children: [
          {
            index: true,
            element: <Profile />,
          },
        ],
      },
    ],
  },

  // Error Pages
  {
    path: "/server-error",
    element: <InternalServerError />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/error",
    element: <ErrorPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: "*",
    element: <NotFoundPage />,
    errorElement: <ErrorPage />,
  },
]);

export default router;
